module.exports = __webpack_public_path__ + "static/media/mergecity-logo@3x.38e6ef35.png";